import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HorizontalNavbarComponent } from './horizontal-navbar.component';
import { CapturumSidebarMenuModule } from '@capturum/ui/sidebar-menu';
import { NavItemComponent } from './nav-item/nav-item.component';
import { CapturumNotificationBadgeModule } from '@capturum/ui/notification-badge';

@NgModule({
  declarations: [
    HorizontalNavbarComponent,
    NavItemComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CapturumSidebarMenuModule,
    CapturumNotificationBadgeModule
  ],
  exports: [
    HorizontalNavbarComponent
  ]
})
export class HorizontalNavbarModule {
}
